import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiPolishBrief(briefMarkdown: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a senior business analyst. Take this raw project brief and produce a polished version: tighten language, surface implicit assumptions, flag gaps, add 3 sharp questions the consultant should ask before kickoff. Preserve all factual content. Output the polished brief in Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: briefMarkdown }],
      temperature: 0.3, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The brief builder works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
